module.exports = __webpack_public_path__ + "img/info-blue-icon.2521c9c1.svg";